export default "__VITE_ASSET__DRPw274p__"